import TYPES from '../types';

export default payload => {
  return {
    type: TYPES.SET_STUDENT_SESSION,
    payload,
  };
};
